import { Component, OnInit, ViewChild } from '@angular/core';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { iconAgregar } from 'src/app/general/variables';

@Component({
  selector: 'app-modal-generar-doc-sgd',
  templateUrl: './modal-generar-doc-sgd.component.html',
  styleUrls: ['./modal-generar-doc-sgd.component.css']
})
export class ModalGenerarDocSgdComponent implements OnInit {

  iconAgregar = iconAgregar;

  // dataSource: MatTableDataSource<Persona>;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;


  constructor() { }

  ngOnInit() {

    this.navModalC.setDatosNavModal2('Generación de Documento de Comunicación');

  }

}
